import PropTypes from 'prop-types';
import cn from 'classnames';
import scrollbarSize from 'dom-helpers/scrollbarSize';
import React from 'react';

import DateContentRow from 'react-big-calendar/lib/DateContentRow';
import Header from 'react-big-calendar/lib/Header';
import ResourceHeader from 'react-big-calendar/lib/ResourceHeader';
import { notify } from 'react-big-calendar/lib/utils/helpers';

import CustomDateHeaderRow from './CustomDateHeaderRow';

export default class CustomTimeGridHeader extends React.Component {
  handleHeaderClick = (date, view, e) => {
    e.preventDefault();
    notify(this.props.onDrillDown, [date, view]);
  };

  renderHeaderCells(range) {
    let {
      localizer,
      components: { header: HeaderComponent = Header },
    } = this.props;

    return range.map((date) => {
      let label = localizer.format(date, 'dayFormat');

      let header = <HeaderComponent date={date} label={label} localizer={localizer} />;

      return header;
    });
  }

  renderRow = (resource) => {
    let { events, rtl, selectable, getNow, range, getters, localizer, accessors, components } = this.props;

    const resourceId = accessors.resourceId(resource);
    let eventsToDisplay = resource ? events.filter((event) => accessors.resource(event) === resourceId) : events;

    return (
      <DateContentRow
        isAllDay
        rtl={rtl}
        getNow={getNow}
        minRows={2}
        range={range}
        events={eventsToDisplay}
        resourceId={resourceId}
        className="rbc-allday-cell"
        selectable={selectable}
        selected={this.props.selected}
        components={components}
        accessors={accessors}
        getters={getters}
        localizer={localizer}
        onSelect={this.props.onSelectEvent}
        onDoubleClick={this.props.onDoubleClickEvent}
        onSelectSlot={this.props.onSelectSlot}
        longPressThreshold={this.props.longPressThreshold}
      />
    );
  };

  render() {
    let {
      rtl,
      resources,
      range,
      events,
      getNow,
      accessors,
      selectable,
      components,
      getters,
      scrollRef,
      localizer,
      isOverflowing,
      className,
      components: { resourceHeader: ResourceHeaderComponent = ResourceHeader },
    } = this.props;

    let style = {};
    if (isOverflowing) {
      style[rtl ? 'marginLeft' : 'marginRight'] = `${scrollbarSize()}px`;
    }

    const groupedEvents = resources.groupEvents(events);

    return (
      <div style={style} ref={scrollRef} className={cn(isOverflowing && 'rbc-overflowing', className)}>
        {resources.map(([id, resource], idx) => (
          <div className={`${className}__content`} key={id || idx}>
            {resource && (
              <div className="rbc-row rbc-row-resource" key={`resource_${idx}`}>
                <div className="rbc-header">
                  <ResourceHeaderComponent index={idx} label={accessors.resourceTitle(resource)} resource={resource} />
                </div>
              </div>
            )}
            <CustomDateHeaderRow
              isAllDay
              rtl={rtl}
              getNow={getNow}
              minRows={2}
              range={range}
              events={groupedEvents.get(id) || []}
              resourceId={resource && id}
              className={'rbc-allday-cell'}
              selectable={selectable}
              selected={this.props.selected}
              components={components}
              accessors={accessors}
              getters={getters}
              localizer={localizer}
              onSelect={this.props.onSelectEvent}
              onDoubleClick={this.props.onDoubleClickEvent}
              onSelectSlot={this.props.onSelectSlot}
              longPressThreshold={this.props.longPressThreshold}
            />
          </div>
        ))}
      </div>
    );
  }
}

CustomTimeGridHeader.propTypes = {
  range: PropTypes.array.isRequired,
  events: PropTypes.array.isRequired,
  resources: PropTypes.object,
  getNow: PropTypes.func.isRequired,
  isOverflowing: PropTypes.bool,

  rtl: PropTypes.bool,
  width: PropTypes.number,

  localizer: PropTypes.object.isRequired,
  accessors: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  getters: PropTypes.object.isRequired,

  selected: PropTypes.object,
  selectable: PropTypes.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: PropTypes.number,

  onSelectSlot: PropTypes.func,
  onSelectEvent: PropTypes.func,
  onDoubleClickEvent: PropTypes.func,
  onDrillDown: PropTypes.func,
  getDrilldownView: PropTypes.func.isRequired,
  scrollRef: PropTypes.any,
};
